import { api } from '../api/client';
import { ADMIN } from '../api/endpoints';
import { buildQuery } from '../api/helpers';

export const analyticsService = {
  overview: (params = {}) =>
    api.get(`${ADMIN.ANALYTICS_OVERVIEW}${buildQuery(params)}`),
  articles: (params = {}) =>
    api.get(`${ADMIN.ANALYTICS_ARTICLES}${buildQuery(params)}`),
  article: (id, params = {}) =>
    api.get(`${ADMIN.ANALYTICS_ARTICLE(id)}${buildQuery(params)}`),
  articlePeople: (id, params = {}) =>
    api.get(`${ADMIN.ANALYTICS_ARTICLE_PEOPLE(id)}${buildQuery(params)}`),
  alerts: (params = {}) =>
    api.get(`${ADMIN.ANALYTICS_ALERTS}${buildQuery(params)}`),
  alert: (id) => api.get(ADMIN.ANALYTICS_ALERT(id)),
  audience: (params = {}) =>
    api.get(`${ADMIN.ANALYTICS_AUDIENCE}${buildQuery(params)}`),
  ops: (params = {}) =>
    api.get(`${ADMIN.ANALYTICS_OPS}${buildQuery(params)}`),
};
